module.exports = __webpack_public_path__ + "static/media/GT-Walsheim-Regular.c3bb319f.woff2";